export const COUNTIES = [
    { code: 'BDFT', name: 'Bedfordshire' },
    { code: 'BSBS', name: 'Berkshire & South Bucks' },
    { code: 'CMBT', name: 'Cambridgeshire' },
    { code: 'CHRN', name: 'Cheshire' },
    { code: 'CWLW', name: 'Cornwall' },
    { code: 'CUMN', name: 'Cumbria' },
    { code: 'DRBA', name: 'Derbyshire' },
    { code: 'DVNW', name: 'Devon' },
    { code: 'DRSW', name: 'Dorset' },
    { code: 'SEDX', name: 'East Scotland' },
    { code: 'ESXQ', name: 'Essex' },
    { code: 'GLUW', name: 'Gloucester' },
    { code: 'HNTS', name: 'Hampshire' },
    { code: 'HRTT', name: 'Hertfordshire' },
    { code: 'KNTQ', name: 'Kent' },
    { code: 'LNCN', name: 'Lancashire' },
    { code: 'LECA', name: 'Leicestershire' },
    { code: 'LNCA', name: 'Lincolnshire' },
    { code: 'SMDX', name: 'Mid Scotland' },
    { code: 'MDXL', name: 'Middlesex' },
    { code: 'NRFT', name: 'Norfolk' },
    { code: 'SNDX', name: 'North Scotland' },
    { code: 'NWAY', name: 'North Wales' },
    { code: 'NHPA', name: 'Northamptonshire' },
    { code: 'NDRE', name: 'Northumberland & Durham' },
    { code: 'NTMA', name: 'Nottinghamshire' },
    { code: 'ONBS', name: 'Oxfordshire & North Bucks' },
    { code: 'SHPM', name: 'Shropshire' },
    { code: 'SMSW', name: 'Somerset' },
    { code: 'STFM', name: 'Staffordshire' },
    { code: 'EWAY', name: 'South East Wales' },
    { code: 'WWAY', name: 'South West Wales' },
    { code: 'SFKT', name: 'Suffolk' },
    { code: 'SRYQ', name: 'Surrey' },
    { code: 'SSXS', name: 'Sussex' },
    { code: 'WWKM', name: 'Warwickshire' },
    { code: 'SCWX', name: 'West Scotland' },
    { code: 'WLTW', name: 'Wiltshire' },
    { code: 'WRCM', name: 'Worcester' },
    { code: 'YRKE', name: 'Yorkshire' },
];
export const detectCountyCode = (region) => {
    if (!region)
        return 'KNTQ';
    const regionLower = region.toLowerCase();
    return COUNTIES.find(c => regionLower.includes(c.name.toLowerCase()))?.code ?? 'KNTQ';
};
// Three counties whose codes end in 'Q' rather than the region letter
const COUNTY_REGION_OVERRIDES = {
    KNTQ: 'S', // Kent → South East
    SRYQ: 'S', // Surrey → South East
    ESXQ: 'T', // Essex → East
};
export const getRegionCodeFromCountyCode = (countyCode) => COUNTY_REGION_OVERRIDES[countyCode] ?? countyCode.slice(-1);
